import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
// materialdesignicons
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import lightDarkTheme from './theme/theme'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: lightDarkTheme
  },
  icons: {
    iconfont: 'mdi' || 'mdiSvg'
  }
})
